import { useEffect as e, useState as t } from "react";
import { Observable as n } from "thrive-observable";
//#region src/useObservable.ts
function r(n) {
	let [r, i] = t(n.value);
	return e(() => {
		let e = (e) => {
			i(e);
		};
		return n.subscribe(e), () => {
			n.unsubscribe(e);
		};
	}, [n]), r;
}
//#endregion
export { n as Observable, r as useObservable };
